// components/pergola/componeti/button_ui.tsx
import { useFrame } from "@react-three/fiber";
import React from "react";

interface ControlPanelProps {
  orientamentoLamelle: "Larghezza" | "Profondità";
  onToggleOrientamento: () => void;
  statoLamelle: boolean;
  onToggleLamelle: () => void;
  statoTenda: boolean;
  onToggleTenda: () => void;
  statoVetrata: boolean;
  onToggleVetrata: () => void;
  hasTendaZip: boolean;
  hasVetrata: boolean;
}


/* STILE PULSANTE  */
const buttonStyle = (color: string): React.CSSProperties => ({
  padding: "8px 14px",               
  border: "none",
  borderRadius: "8px",               
  cursor: "pointer",
  fontSize: "13px",                  
  fontWeight: 600,
  color: "white",
  background: `linear-gradient(135deg, ${color}dd, ${color}cc)`,
  boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
  transition: "all 0.25s ease",
  position: "relative" as const,
  overflow: "hidden",
  minWidth: "130px",                 
  fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  whiteSpace: "nowrap",
});

export const ControlPanel: React.FC<ControlPanelProps> = ({
  orientamentoLamelle,
  onToggleOrientamento,
  statoLamelle,
  onToggleLamelle,
  statoTenda,
  onToggleTenda,
  statoVetrata,
  onToggleVetrata,
  hasTendaZip,
  hasVetrata
}) => {
  return (
    <div
      style={{
        position: "absolute",
        top: "20px",
        left: "20px",
        zIndex: 1000,
        display: "flex",
        gap: "8px",                     
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
        flexWrap: "nowrap",
        padding: "6px 0",               
        WebkitOverflowScrolling: "touch",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      }}
    >
      {/* LAMELLE ORIENTAMENTO 
      <button
        onClick={onToggleOrientamento}
        style={buttonStyle("#f59e0b")}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-2px) scale(1.03)";
          e.currentTarget.style.boxShadow = "0 6px 14px rgba(0,0,0,0.25)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0) scale(1)";
          e.currentTarget.style.boxShadow = "0 2px 6px rgba(0,0,0,0.2)";
        }}
      >
        Lamelle: {orientamentoLamelle}
      </button>*/}

      {/* APRI/CHIUDI LAMELLE */}
      <button
        onClick={onToggleLamelle}
        style={buttonStyle("#3b82f6")}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-2px) scale(1.03)";
          e.currentTarget.style.boxShadow = "0 6px 14px rgba(0,0,0,0.25)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0) scale(1)";
          e.currentTarget.style.boxShadow = "0 2px 6px rgba(0,0,0,0.2)";
        }}
      >
        {statoLamelle ? "Chiudi Lamelle" : "Apri Lamelle"}
      </button>

      {/* TENDE ZIP */}
      {hasTendaZip && (
        <button
          onClick={onToggleTenda}
          style={buttonStyle("#10b981")}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-2px) scale(1.03)";
            e.currentTarget.style.boxShadow = "0 6px 14px rgba(0,0,0,0.25)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0) scale(1)";
            e.currentTarget.style.boxShadow = "0 2px 6px rgba(0,0,0,0.2)";
          }}
        >
          {statoTenda ? "Chiudi Tenda" : "Apri Tenda"}
        </button>
      )}
      {/* VETRATE */}
      {hasVetrata && (
        <button
          onClick={onToggleVetrata}
          style={buttonStyle("#8b5cf6")}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-2px) scale(1.03)";
            e.currentTarget.style.boxShadow = "0 6px 14px rgba(0,0,0,0.25)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0) scale(1)";
            e.currentTarget.style.boxShadow = "0 2px 6px rgba(0,0,0,0.2)";
          }}
        >
          {statoVetrata ? "Chiudi Vetrata" : "Apri Vetrata"}
        </button>
      )}
    </div>
  );
};

const CameraLogger = () => {
  useFrame(({ camera }) => {
    console.log(
      camera.position.x.toFixed(2),
      camera.position.y.toFixed(2),
      camera.position.z.toFixed(2)
    );
  });

  return null;
};

export default CameraLogger;